import type { PropTypes } from './HoverCard.types';
import type { ReactElement } from 'react';

import { HoverCard as RadixHoverCard, Text } from '@rango-dev/whale';
import React from 'react';

import { useWindowDimensions } from '../../../hooks/useWindowDimensions';
import { InfoIconButton } from '../../common/InfoIconButton';

import styles from './HoverCard.module.css';

const DEFAULT_ICON_SIZE = 12;
const DEFAULT_SIDE_OFFSET = 8;
const MOBILE_COLLISION_PADDING = 80;

export function HoverCard(props: PropTypes): ReactElement {
  const {
    description,
    sideOffset = DEFAULT_SIDE_OFFSET,
    iconSize = DEFAULT_ICON_SIZE,
    trigger,
  } = props;
  const { isMobile } = useWindowDimensions();

  return (
    <RadixHoverCard.Root>
      <RadixHoverCard.Trigger>
        {trigger ?? (
          <InfoIconButton
            id="profile-hover-card-info-btn"
            iconSize={iconSize}
            aria-label={description}
          />
        )}
      </RadixHoverCard.Trigger>
      <RadixHoverCard.Content
        size="2"
        side="top"
        align="start"
        sideOffset={sideOffset}
        maxWidth="250px"
        collisionPadding={isMobile ? { bottom: MOBILE_COLLISION_PADDING } : undefined}
        className={styles.content}>
        <Text size="1" className={styles.description}>
          {description}
        </Text>
      </RadixHoverCard.Content>
    </RadixHoverCard.Root>
  );
}
